import * as _ from 'lodash'
import { MonitoringLocalStorage } from '../../util/storage/MonitoringLocalStorageManager'
import MonitoringLocalStorageManager from '../../util/storage/MonitoringLocalStorageManager'

export const getResourceIdFromLS = (resourceName: string, origin: keyof MonitoringLocalStorage) => {
  const trimmedCamelCaseResourceName = _.startCase(_.camelCase(resourceName.trim()))
  const lsData = MonitoringLocalStorageManager.get(origin)

  return lsData && lsData[`selected${trimmedCamelCaseResourceName}`]
}

export const saveResourceIdInLS = (resourceName: string, origin: keyof MonitoringLocalStorage, resourceId: string | null) => {
  const trimmedCamelCaseResourceName = _.startCase(_.camelCase(resourceName.trim()))
  const lsData = MonitoringLocalStorageManager.get(origin)

  if (lsData) {
    const newData = {...lsData}
    newData[`selected${trimmedCamelCaseResourceName}`] = resourceId
    MonitoringLocalStorageManager.put(origin, newData)
  }
}
